module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tw-h-full noselect"
  }, [_c('Form', {
    ref: "formSortieSalarie",
    staticClass: "tw-h-full",
    attrs: {
      "readonly": _vm.readOnly,
      "dataForm": _vm.dataForm
    },
    on: {
      "update:dataForm": function($event) {
        _vm.dataForm = $event
      }
    }
  }, [_c('div', {
    staticClass: "tw-h-full"
  }, [(!_vm.dataReady) ? _c('div', {
    staticClass: "tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-bg-gray-500/10 tw-z-10"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('VerticalScroll', {
    ref: "scrollFormSortieSalarie",
    staticClass: "tw-h-full",
    attrs: {
      "padding": true
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-h-full"
  }, [_c('div', {
    staticClass: "tw-w-1/2 tw-h-full tw-mr-2"
  }, [_c('div', {
    staticClass: "tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-between tw-mb-0.5"
  }, [_c('Title', [_vm._v("Salarié")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-full",
    attrs: {
      "data-testid": "exitRequest-salarie-field"
    }
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.salarie,
      "listOption": _vm.transformListSalarie(_vm.listeSalarie),
      "maxHeight": 450
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "salarie", $event)
      },
      "changed": function($event) {
        _vm.changed('salarie')
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('div', {
    staticClass: "horaires-presence-field"
  }, [_c('div', {
    staticClass: "inp-input icon horaires-presence-inp",
    class: {
      warning: (_vm.showHorairesPresenceAlerte || _vm.hasHorairesError) && _vm.hasSalarieSelected,
        'horaires-presence-inp--vide': !_vm.horairesPresenceRenseignes && !_vm.hasHorairesError,
        'is-disabled': _vm.readOnly || !_vm.dataReady || !_vm.hasSalarieSelected
    },
    attrs: {
      "data-testid": "horaires-presence-field"
    },
    on: {
      "click": function($event) {
        !_vm.readOnly && _vm.dataReady && _vm.openHoraireHebdo()
      }
    }
  }, [_c('input', {
    key: _vm.horairesPresenceLibelle,
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": "",
      "disabled": _vm.readOnly || !_vm.dataReady,
      "placeholder": " ",
      "title": _vm.isTempsPartiel() ? 'Les horaires de présence sont obligatoires pour ce contrat' : 'Horaires de présence'
    },
    domProps: {
      "value": _vm.horairesPresenceLibelle
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Horaires de présence")]), _vm._v(" "), ((_vm.showHorairesPresenceAlerte || _vm.hasHorairesError) && _vm.hasSalarieSelected) ? _c('span', {
    staticClass: "icon-alerte ri-alert-line"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "icon-inner ri-pencil-line"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-0.5"
  }, [_c('Title', [_vm._v("Éléments variables")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.heuresmois
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "heuresmois", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.transport
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "transport", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12",
    attrs: {
      "data-testid": "exitRequest-titresRestau-field"
    }
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.restaurant
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "restaurant", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-6/12 tw-mr-3"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.cprestant
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "cprestant", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.rttrestant
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "rttrestant", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('Checkbox', {
    attrs: {
      "disabled": _vm.readOnly,
      "vmodel": _vm.sortieSalarie.IndemniteCDD,
      "label": "Indemnité CDD",
      "title": "Indemnité CDD"
    },
    on: {
      "changed": _vm.changed,
      "update:vmodel": function($event) {
        _vm.$set(_vm.sortieSalarie, "IndemniteCDD", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3"
  }, [_c('Checkbox', {
    attrs: {
      "disabled": _vm.readOnly,
      "vmodel": _vm.sortieSalarie.IndemniteTreiziemeMois,
      "label": "Indemnité 13ème mois",
      "title": "Indemnité 13ème mois"
    },
    on: {
      "changed": _vm.changed,
      "update:vmodel": function($event) {
        _vm.$set(_vm.sortieSalarie, "IndemniteTreiziemeMois", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12",
    attrs: {
      "data-testid": "exitRequest-modeReglement-field"
    }
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.reglement,
      "listOption": _vm.listeReglement
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "reglement", $event)
      },
      "changed": _vm.changed
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-1/2 tw-h-full tw-ml-2 "
  }, [_c('div', {
    staticClass: "tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-0.5"
  }, [_c('Title', [_vm._v("Éléments de sortie")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5"
  }, [_c('div', {
    staticClass: "tw-flex tw-mb-2"
  }, [_c('div', {
    staticClass: "tw-w-4/12 tw-mr-3",
    attrs: {
      "data-testid": "exitRequest-dateDepart-field"
    }
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateDepart
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateDepart", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12 tw-mr-3",
    attrs: {
      "data-testid": "exitRequest-dernierJour-field"
    }
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateDernier
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateDernier", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-4/12"
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateNotif
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateNotif", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-full",
    attrs: {
      "data-testid": "exitRequest-refusCdiSuiteCdd-field"
    }
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.refusCdiSuiteCdd,
      "listOption": _vm.listeBooleen
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "refusCdiSuiteCdd", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-full",
    attrs: {
      "data-testid": "exitRequest-motif-field"
    }
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.motif,
      "listOption": _vm.transformList(_vm.listeMotifsDepart),
      "maxHeight": 350
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "motif", $event)
      },
      "changed": function($event) {
        _vm.changed('motif')
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-space-x-3",
    class: {
      'tw-hidden': _vm.dataForm.motif.vmodel !== '012'
    }
  }, [_c('div', {
    staticClass: "tw-w-9/12"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.motifLicenciement,
      "listOption": _vm.listeMotifLicenciement,
      "maxHeight": 300
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "motifLicenciement", $event)
      },
      "changed": function($event) {
        _vm.changed('motifLicenciement')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-3/12"
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateLicenciement
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateLicenciement", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-space-x-3",
    class: {
      'tw-hidden': _vm.dataForm.motif.vmodel !== '010' && _vm.dataForm.motif.vmodel !== '012'
    }
  }, [_c('div', {
    staticClass: "tw-w-6/12"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.typePreavis,
      "listOption": _vm.transformList(_vm.listeTypesPreavis)
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "typePreavis", $event)
      },
      "changed": function($event) {
        _vm.changed('typePreavis')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-3/12",
    class: {
      'tw-hidden': _vm.dataForm.typePreavis.vmodel === 'PASPR'
    }
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.debutPreavis
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "debutPreavis", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-3/12",
    class: {
      'tw-hidden': _vm.dataForm.typePreavis.vmodel === 'PASPR'
    }
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.finPreavis
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "finPreavis", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-space-x-3",
    class: {
      'tw-hidden': _vm.dataForm.motif.vmodel !== '138'
    }
  }, [_c('div', {
    staticClass: "tw-w-9/12"
  }, [_c('InputDecimalForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.montantIndemnite
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "montantIndemnite", $event)
      },
      "changed": _vm.changed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-3/12"
  }, [_c('InputDateForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.dateSignature
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "dateSignature", $event)
      },
      "changed": _vm.changed
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-space-x-3",
    class: {
      'tw-hidden': _vm.dataForm.motif.vmodel !== '903'
    }
  }, [_c('div', {
    staticClass: "tw-w-full"
  }, [_c('SelectForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.autreMotif,
      "listOption": _vm.transformList(_vm.listeMotif),
      "maxHeight": 250
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "autreMotif", $event)
      },
      "changed": function($event) {
        _vm.changed('autreMotif')
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tw-flex tw-items-center tw-justify-between tw-mb-0.5"
  }, [_c('Title', [_vm._v("Autres informations")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-border tw-rounded tw-p-5 "
  }, [_c('div', {
    staticClass: "tw-flex"
  }, [_c('div', {
    staticClass: "tw-w-full"
  }, [_c('TextareaForm', {
    attrs: {
      "dataInputOption": _vm.dataForm.divers
    },
    on: {
      "update:dataInputOption": function($event) {
        _vm.$set(_vm.dataForm, "divers", $event)
      },
      "changed": _vm.changed
    }
  })], 1)])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "boutons-actions"
  }, [_c('div', {
    staticClass: "tw-inline-flex tw-border tw-p-5 tw-rounded tw-shadow tw-bg-white"
  }, [_c('Button', {
    class: {
      'tw-mr-3': !_vm.readOnly
    },
    attrs: {
      "icon": "fa-solid fa-circle-xmark",
      "color": "red",
      "disabled": !_vm.dataReady,
      "outline": true,
      "title": !_vm.readOnly ? 'Annuler les modifications' : 'Fermer',
      "text": !_vm.readOnly ? 'Annuler les modifications' : 'Fermer'
    },
    on: {
      "click": function($event) {
        _vm.cancelButton()
      }
    }
  }), _vm._v(" "), (!_vm.readOnly) ? _c('Button', {
    staticClass: "tw-mr-3",
    attrs: {
      "data-testid": "exitRequest-save-button",
      "icon": "fa-solid fa-floppy-disk",
      "color": "blue",
      "disabled": !_vm.isModified || !_vm.dataReady,
      "title": this.sortieSalarie.Id === 0 ? 'Enregistrer la saisie' : 'Modifier la saisie',
      "text": this.sortieSalarie.Id === 0 ? 'Enregistrer la saisie' : 'Modifier la saisie'
    },
    on: {
      "click": function($event) {
        _vm.saveButton()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.readOnly && _vm.canValider()) ? _c('Button', {
    attrs: {
      "data-testid": "exitRequest-validate-button",
      "icon": "fa-solid fa-paper-plane-top",
      "color": "green",
      "disabled": !_vm.dataReady,
      "title": 'Valider la sortie',
      "text": 'Valider la sortie'
    },
    on: {
      "click": function($event) {
        _vm.validate()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.readOnly && _vm.canSoumettre()) ? _c('Button', {
    attrs: {
      "data-testid": "exitRequest-send-button",
      "icon": "fa-solid fa-paper-plane-top",
      "color": "green",
      "disabled": !_vm.dataReady,
      "title": 'Transmettre',
      "text": 'Transmettre'
    },
    on: {
      "click": function($event) {
        _vm.submitButton()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('modal-absences-futures-fin-de-contrat', {
    ref: "modalAbsencesFuturesFinDeContrat",
    attrs: {
      "data-backdrop": "static"
    }
  }), _vm._v(" "), (_vm.showModalHoraireHebdo) ? _c('modal-horaire-hebdo', {
    attrs: {
      "horaire-hebdo-initial": _vm.horaireHebdoPourModale,
      "heuresParSemaine": _vm.libelleHeuresPourModale
    },
    on: {
      "horaireHebdoUpdated": _vm.onHoraireHebdoUpdated,
      "closeModal": function($event) {
        _vm.showModalHoraireHebdo = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2412b2f4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sortieSalarie/sortieSalarie.vue.html
// module id = MAS1
// module chunks = 2